<template>

  <div class="container-fluid">
    

    <div class="row starter-main">

      <!-- Tarjeta 1 -->
      <div class="col-sm-12 mt-3">
        <div class="card">
          <div class="card-body text-center">
            <h5>Te damos la bienvenida a la nueva versión del SIMM!</h5>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-6">
        <div class="card compare-order">
          <div class="card-header card-no-border">
            <div class="header-top">
              <div class="compare-icon shadow-primary">
                <vue-feather type="shield" size="40" class="txt-primary"></vue-feather>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <span class="f-w-500 c-o-light">Total de Pólizas</span>
            <h4 class="mb-2"><span class="counter">{{ formatNumber(generalStats.totalPolicies) }}</span></h4>
            <div class="progress" role="progressbar">
              <div class="progress-bar bg-primary" style="width: 8%;"></div>
            </div>
            <span class="user-growth f-12 f-w-500">
              <i class="icon-arrow-down txt-danger"></i>
              <span class="txt-danger">+1.3%</span>
            </span>
            <span class="user-text"> respecto al último mes</span>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-6">
        <div class="card compare-order">
          <div class="card-header card-no-border">
            <div class="header-top">
              <div class="compare-icon shadow-primary">
                <vue-feather type="user" size="40" class="txt-primary"></vue-feather>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <span class="f-w-500 c-o-light">Clientes</span>
            <h4 class="mb-2"><span class="counter">{{ formatNumber(generalStats.totalClientes) }}</span></h4>
            <div class="progress" role="progressbar">
              <div class="progress-bar bg-primary" style="width: 58%;"></div>
            </div>
            <span class="user-growth f-12 f-w-500">
              <i class="icon-arrow-down txt-danger"></i>
              <span class="txt-danger">+4.3%</span>
            </span>
            <span class="user-text"> respecto al último mes</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="card compare-order">
          <div class="card-header card-no-border">
            <div class="header-top">
              <div class="compare-icon shadow-primary">
                <vue-feather type="alert-octagon" size="40" class="txt-primary"></vue-feather>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <span class="f-w-500 c-o-light">Trámites pendientes</span>
            <h4 class="mb-2"><span class="counter">{{ formatNumber(generalStats.TramitesPendientes) }} / {{ formatNumber(generalStats.TramitesTotales) }}</span></h4>
            <div class="progress" role="progressbar">
              <div class="progress-bar bg-primary" :style="{ width: Math.ceil(generalStats.PorcentajeTramitesPendientes) + '%' }"></div>
            </div>
            <span class="user-growth f-12 f-w-500">
              <i class="icon-arrow-down txt-danger"></i>
              <span class="txt-danger">{{ generalStats.PorcentajeTramitesPendientesLastMonth }}%</span>
            </span>
            <span class="user-text"> respecto al último mes</span>
          </div>
        </div>
      </div>

      <!-- Tarjeta 2 -->
      <div class="col-md-6">
        <div class="card">
          
          <div class="card-body">
            <div class="image-container mb-3">
              <img class="img-fluid" src="@/assets/images/dashboard/finance.png" alt="">
            </div>            
          </div>
        </div>
      </div>

       <!-- Tarjeta 2 -->
      <div class="col-md-6">
        <div class="card">
          
          <div class="card-body">
            <div class="image-container mb-3">
              <img class="img-fluid" src="@/assets/images/dashboard/week.png" alt="">
            </div>            
          </div>
        </div>
      </div>

            <!-- Tarjeta 2 -->
      <div class="col-md-6">
        <div class="card">
          
          <div class="card-body">
            <div class="image-container mb-3">
              <img class="img-fluid" src="@/assets/images/dashboard/sales.png" alt="">
            </div>            
          </div>
        </div>
      </div>

       <!-- Tarjeta 2' -->
      <div class="col-md-6">
        <div class="card">
          
          <div class="card-body">   
            <div class="image-container mb-3">
              <img class="img-fluid" src="@/assets/images/dashboard/personajeMM.jpg" alt="">
            </div>                       
            <p></p>
          </div>
        </div>
      </div>

            <div class="card o-hidden crm-card">

      </div>


    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import api from '@/axios';

export default {
  name: 'DefaultPage',
  data() {
    return {
      generalStats: {
        totalPolicies: 0,
        activePolicies: 0,
        inactivePolicies: 0,
        totalClientes: 0,
        totalClientesLastMonth: 0,
        TramitesTotales: 0,
        TramitesPendientes: 0,
        TramitesLastMonth: 0,
        TramitesPendientesLastMonth: 0,
        PorcentajeTramitesPendientes: 0,
        PorcentajeTramitesPendientesLastMonth: 0
      },
    };
  },
  created() {
    this.fetchGeneralStats();
  },
  methods: {
    formatNumber(val) {
      // Fuerza coma "," como separador de miles, sin depender del locale del navegador
      return (Number(val) || 0).toLocaleString('en-US');
    },

    async fetchGeneralStats() {
      try {
        const { data } = await api.get('dashboard/stats');
        this.generalStats = {
          totalPolicies: Number(data?.totalPolicies) || 0,
          activePolicies: Number(data?.activePolicies) || 0,
          inactivePolicies: Number(data?.inactivePolicies) || 0,
          totalClientes: Number(data?.totalClientes) || 0,
          totalClientesLastMonth: Number(data?.totalClientesLastMonth) || 0,

          TramitesTotales: Number(data?.tramitesTotales) || 0,
          TramitesPendientes: Number(data?.tramitesPendientes) || 0,
          TramitesLastMonth: Number(data?.tramitesLastMonth) || 0,
          TramitesPendientesLastMonth: Number(data?.tramitesPendientesLastMonth) || 0,
          PorcentajeTramitesPendientes: Number(data?.porcentajeTramitesPendientes) || 0,
          PorcentajeTramitesPendientesLastMonth: Number(data?.porcentajeTramitesPendientesLastMonth) || 0

        };
      } catch (error) {
        console.error('Error al cargar las estadisticas de polizas:', error);
      }
    },
  },
};
</script>

<style scoped>
.starter-main .card .card-header {
  background: #fff !important;
  background-image: none !important;
}
</style>